import '../Sass/App.scss';
import React, { useState, useCallback } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../Helpers/cropImage';

export function EditGameInfo(props) {

    const [gameData, setGameData] = useState({...props.gameData});

    const [name, setName] = useState(props.gameData.name);
    const [flavor, setFlavor] = useState(props.gameData.flavor);
    const [description, setDescription] = useState(props.gameData.description);
    const [imageSrc, setImageSrc] = useState(props.featuredImage);
    const [defaultBackImageSrc, setDefaultBackImageSrc] = useState(props.defaultBackImage);
    const [featuredImageChanged, setFeaturedImageChanged] = useState(false);
    const [defaultBackImageChanged, setDefaultBackImageChanged] = useState(false);

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [defaultBackCrop, setDefaultBackCrop] = useState({ x: 0, y: 0 });
    const [defaultBackZoom, setDefaultBackZoom] = useState(1);

    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [defaultBackCroppedAreaPixels, setDefaultBackCroppedAreaPixels] = useState(null);

    function changeData(event, changer, elem) {
        const newValue = event.target.value;

        changer(newValue);

        const newGameData = {
            ...gameData,
            [elem]: newValue
        };

        setGameData(newGameData);
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const onDefaultBackCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setDefaultBackCroppedAreaPixels(croppedAreaPixels);
    }, []);

    async function onFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setImageSrc(reader.result);
            setFeaturedImageChanged(true);
        };
        reader.readAsDataURL(file);
    }

    async function onDefaultBackFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setDefaultBackImageSrc(reader.result);
            setDefaultBackImageChanged(true);
        };
        reader.readAsDataURL(file);
    }

    async function saveChanges() {
        const updatedData = {...gameData};

        if (featuredImageChanged && imageSrc) {
            updatedData.featured_image = croppedAreaPixels ? await getCroppedImg(imageSrc, croppedAreaPixels) : imageSrc;
        }

        if (defaultBackImageChanged && defaultBackImageSrc) {
            updatedData.default_back_image = defaultBackCroppedAreaPixels ? await getCroppedImg(defaultBackImageSrc, defaultBackCroppedAreaPixels) : defaultBackImageSrc;
        }

        props.changeHandler(updatedData);
    }

    return (
        <Grid container spacing={2}>
            <Grid xs={12}>
                <h4>Edit Game Information</h4>
                <div style={{float: 'left', display: 'block', width: '100%'}}>
                    <div className="codebase-select-div" style={{marginBottom: 10}}>
                        <div className='green-code'>Name</div>
                        <span className='explanation'>Name of the Codebase you're developing. This should be fewer than 40 characters.</span>
                        <input className="codebase-select" value={name} onChange={(e) => changeData(e,setName,'name')} style={{fontSize: '1em', width: '100%'}} />
                    </div>
                    <div className='green-code'>Description</div>
                    <span className='explanation'>Description of your Codebase. This should be a single, catchy sentence.</span>
                    <div className="codebase-select-div" style={{marginBottom: 10}}>
                        <textarea rows='4' className="codebase-select" value={description} onChange={(e) => changeData(e,setDescription,'description')} style={{fontSize: '1em', width: '100%'}} />
                    </div>
                    <div className='green-code'>Flavor Text</div>
                    <span className='explanation'>A slightly longer description of your Codebase. Thus can be a a few sentences, and should supplement the description above.</span>
                    <div className="codebase-select-div" style={{marginBottom: 10}}>
                        <textarea rows='4' className="codebase-select" value={flavor} onChange={(e) => changeData(e,setFlavor,'flavor')} style={{fontSize: '1em', width: '100%'}} />
                    </div>
                    <div className="codebase-select-div" style={{marginBottom: 10}}>
                        <div className='green-code'>Banner Image</div>
                        <span className='explanation'>This image will be displayed at the top of your codebase's documentation page.</span>
                        <div style={{marginTop: 5}}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onFileChange}
                            />
                            {imageSrc && (
                                <div
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        height: 300,
                                        background: '#222',
                                        marginTop: 20
                                    }}
                                >
                                    <Cropper
                                        image={imageSrc}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={4 / 1}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="codebase-select-div" style={{marginBottom: 10}}>
                        <div className='green-code'>Default card back</div>
                        <span className='explanation'>Cards use this shared back image unless an individual card has a back image override. Default backs use a 1:1.4 portrait crop.</span>
                        <div style={{marginTop: 5}}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onDefaultBackFileChange}
                            />
                            {defaultBackImageSrc && (
                                <div
                                    style={{
                                        position: 'relative',
                                        width: 'min(320px, 100%)',
                                        height: 448,
                                        background: '#222',
                                        marginTop: 20
                                    }}
                                >
                                    <Cropper
                                        image={defaultBackImageSrc}
                                        crop={defaultBackCrop}
                                        zoom={defaultBackZoom}
                                        aspect={1 / 1.4}
                                        onCropChange={setDefaultBackCrop}
                                        onZoomChange={setDefaultBackZoom}
                                        onCropComplete={onDefaultBackCropComplete}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', float: 'right'}}>
                    <button className="cli-button-white" onClick={() => props.setModifyOpen(false)}>cancel</button>
                    <button className="cli-button" onClick={saveChanges}>save</button>
                </div>                

            </Grid>

        </Grid>
    );
}
